import { styled, css } from 'styled-components'
import { themeStyles, themeMedia } from '../../../styles/theme'

export const StyledBottomBar = styled.div`
  ${themeMedia.maxMobile`
    position: fixed;
    width: 100%;
    z-index: 3015; //higher than kambi betslip, lower than side menu
    height: 64px;
    bottom: -1px;
    display: flex;
    align-items: center;
    background-color: #000;
    a {
      text-decoration: none;
    }
    > div {
      height: 100%; 
    }
  `}
  display: none;
`

export const StyledBottomBarAnchor = styled.div`
  ${themeMedia.maxMobile`
    display: block;
    width: 100%;
    height: 0px;
    position: fixed;
    bottom: 63px;
    z-index: 1000;
  `}
  display: none;
`

export const StyledBottomNavButton = styled.a`
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 56px;
  background-color: #000;
  border-bottom: 3px solid transparent;
  ${({ $selected }) => {
    return (
      $selected &&
      css`
        border-bottom: 3px solid #da0000;
      `
    )
  }}
`

export const StyledBottomNavButtonIcon = styled.img`
  height: 30px;
  filter: opacity(0.7);
  ${({ $selected }) =>
    $selected &&
    css`
      filter: opacity(1);
    `}
`

export const StyledBottomNavButtonLabel = styled.p`
  margin: 0;
  color: #fff;
  font-size: 9px;
  line-height: 1;
  text-wrap: wrap;
  text-align: center;
  filter: opacity(0.7);

  ${({ $selected }) =>
    $selected &&
    css`
      filter: opacity(1);
    `}
`
export const StyledBottomNavChangeContextButton = styled.img`
  height: 48px;
`

export const StyledBubbleContent = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) translateX(-0.5px);
  text-align: center;
`;

export const StyledNotificationBubbleContainer = styled.div`
  position: relative;
`;

export const StyledBottomNavNotificationBubble = styled.span`
  position: absolute;
  top: -2px;
  right: ${props => {
    if (props.$is99Plus) return '-16px';
    if (props.$isSingleDigit) return '-5px';
    return '-11px';
  }};
  background: ${themeStyles.colors.accentColors.secondary.main};
  color: ${themeStyles.colors.black.main};
  font-family: 'Inter', sans-serif;
  font-size: 10px;
  font-weight: 700;
  line-height: 9px;
  width: ${props => {
    if (props.$is99Plus) return '27px';
    if (props.$isSingleDigit) return '16px';
    return '22px';
  }};
  height: 16px;
  border-radius: 7.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 20;
  white-space: nowrap;
`;
